import { callApi } from 'utils/api/callApi'
import { FP_ENDPOINTS } from 'apps/fleet-planner/config'
import * as Types from 'apps/fleet-planner/types'

export const fetchDispatchers = (
  params?: Types.IFetchDispatcherParams
): Promise<Types.IGetDispatchersResponse> => {
  return callApi({
    endpoint: FP_ENDPOINTS.dispatchers,
    method: 'GET',
    params: {
      ...params,
    },
  })
}
